// import routes from '@/modules/review/review-routes';
import store from '@/modules/review/review-store';

export default {
  // routes,
  store,
};
